import { updateStories } from '~/actions/stories';
import { getScenarios } from '~/api/scenarios';

export const setStories =
  ({ enqueueSnackbar, showNoStoriesNotification = false }) =>
  async (dispatch) => {
    const { stories } = await getScenarios();

    if (stories.length === 0 && showNoStoriesNotification) {
      enqueueSnackbar('Stories list is empty', { variant: 'warning' });
    }

    const scenarios = stories.map((story) => ({
      story_id: story.id,
      name: story.name,
      origin: story.origin,
    }));

    dispatch(updateStories(scenarios));
  };
